import React from "react";
const FooterAd = () => {
  return (
    <div className="section">
      {/* <div className="container">
        <div className="spot_bottom">
          <img
            src="https://vip.netvideogirls.com/mav2/images/slide01.jpg"
            alt=""
          />
        </div>
      </div> */}
    </div>
  );
};

export default FooterAd;
